/**
 * Prolean cart drawer — “you may also like” loader.
 * Fills #prolean-upsell-slot with Shopify product recommendations for the first
 * cart item, re-running whenever the drawer re-renders or the cart updates.
 */
(() => {
  'use strict';
  if (window.__proleanCartDrawer) return;
  window.__proleanCartDrawer = true;

  const SLOT = '#prolean-upsell-slot';
  let inflight = false;

  async function fill() {
    const slot = document.querySelector(SLOT);
    if (!slot || slot.dataset.filled === '1' || inflight) return;
    const pid = slot.dataset.productId;
    if (!pid) return;
    slot.dataset.filled = '1';
    inflight = true;
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const url = `${root}recommendations/products?section_id=prolean-cart-upsell&product_id=${pid}&limit=2&intent=related`;
      const res = await fetch(url);
      const text = await res.text();
      const block = new DOMParser().parseFromString(text, 'text/html').querySelector('.prolean-cart-upsell');
      if (block) {
        slot.replaceChildren(block);
      } else {
        slot.dataset.filled = '0';
      }
    } catch (e) {
      slot.dataset.filled = '0';
    } finally {
      inflight = false;
    }
  }

  let pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      fill();
    });
    setTimeout(fill, 350);
  }

  function start() {
    schedule();
    const drawer = document.querySelector('cart-drawer') || document.body;
    new MutationObserver(() => schedule()).observe(drawer, { childList: true, subtree: true });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => schedule());
    }
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start, { once: true }) : start();
})();
